import ElementListView from '@/components/ElementListField/ElementListView';
import FieldListEditor from '@/components/ElementListField/FieldListEditor';
import MunicipalitySelect from '@/components/MunicipalitySelect';
import PhoneEditor from '@/components/PhoneNumberField/PhoneEditor';
import Phones from '@/components/PhoneNumberField/PhonesListView';
import ProvinceSelect from '@/components/ProvinceSelect';
import { validations } from '@/utils/fields';
import { renderMunicipality, renderProvince } from '@/utils/location';

export const fields = [
  {
    key: 'code',
    label: 'code',
    colSpan: 2,
    required: true
  },
  {
    key: 'name',
    label: 'notaryOffices.name.label',
    colSpan: 2,
    required: true,
    className: 'form-view-mode-vertical-item'
  },
  {
    key: 'phones',
    label: 'notaryOffices.phone.label',
    required: true,
    widget: PhoneEditor,
    viewWidget: Phones,
    widgetProps: {
      haveType: true
    },
    viewWidgetProps: {
      columns: true,
      useLink: false
    },
    className: 'form-view-mode-vertical-item',
    rules: [validations.listPhones(), validations.phoneValidator()],
  },
  {
    key: 'emails',
    required: false,
    label: 'notaryOffices.email.label',
    widget: FieldListEditor,
    viewWidget: ElementListView,
    viewWidgetProps: {
      columns: true
    },
    widgetProps: {
      validations: [{ required: true }, { type: 'email' }],
      translate: 'notary',
      actionText: 'notaryOffices.email.addToList'
    },
    className: 'form-view-mode-vertical-item'
  },
  {
    key: 'address.province',
    label: 'province',
    required: true,
    onlyEdit: true,
    colSpan: 1,
    widget: ProvinceSelect
  },
  {
    key: 'address.province',
    required: true,
    label: 'province',
    onlyView: true,
    widget: ProvinceSelect,
    viewWidget: ({ value }) => renderProvince(value)
  },
  {
    key: 'address.municipality',
    label: 'municipality',
    required: true,
    onlyEdit: true,
    colSpan: 1,
    related: 'address.province',
    relatedKey: 'province',
    widget: MunicipalitySelect
  },
  {
    key: 'address.municipality',
    required: true,
    onlyView: true,
    label: 'municipality',
    viewWidget: ({ value }) => renderMunicipality(value)
  },
  {
    key: 'address.abstract',
    label: 'address',
    widget: 'textarea',
    className: 'form-view-mode-vertical-item'
  },
];
